export class MemoriaStoneModel {
    get levels() {
        return Object.keys(this.stats).map(key => parseInt(key));
    }
    max() {
        const maxLevel = this.levels[2];
        return {
            hp: this.stats[maxLevel].hp,
            atk: this.stats[maxLevel].atk,
            def: this.stats[maxLevel].def
        };
    }
    adorned() {
        const maxLevel = this.levels[2];
        return {
            hp: this.stats[maxLevel].hp + this.adornments.hp,
            atk: this.stats[maxLevel].atk + this.adornments.atk,
            def: this.stats[maxLevel].def + this.adornments.def
        };
    }
    get rarity() {
        switch (this.levels[1]) {
            case 30: return 'R';
            case 40: return 'SR';
            case 50: return 'SSR';
        }
    }
    static fromData(data) {
        return Object.assign(Object.create(MemoriaStoneModel.prototype), data);
    }
    static fromDataArray(data) {
        return data.map(stone => Object.assign(Object.create(MemoriaStoneModel.prototype), stone));
    }
}
